import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, isAuthenticated, user } = useAuth();
  const navigate = useNavigate();

  // Redirect if already logged in
  if (isAuthenticated) {
    return (
      <div style={{
        minHeight: '60vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem'
      }}>
        <div style={{
          maxWidth: '400px',
          textAlign: 'center'
        }}>
          <h2 style={{ marginBottom: '1rem' }}>Välkommen, {user?.username}!</h2>
          <p style={{ color: 'var(--text-soft)', marginBottom: '2rem' }}>
            Du är inloggad som {getRoleName(user?.role)}.
          </p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            <Link to="/styrelsen/dashboard" className="btn btn-primary">
              Gå till dashboard
            </Link>
            <Link to="/" className="btn btn-ghost">
              Till startsidan
            </Link>
          </div>
        </div>
      </div>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(username, password);
    
    if (result.success) {
      navigate('/styrelsen/dashboard');
    } else {
      setError(result.error);
    }
    
    setLoading(false);
  };

  return (
    <div style={{
      minHeight: '60vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem',
      background: 'var(--forest)'
    }}>
      <div style={{
        width: '100%',
        maxWidth: '400px',
        background: 'var(--white)',
        borderRadius: '8px',
        padding: '2.5rem',
        boxShadow: '0 10px 40px rgba(0,0,0,.2)'
      }}>
        <h2 style={{
          fontFamily: '"Playfair Display", serif',
          fontSize: '1.5rem',
          color: 'var(--forest)',
          marginBottom: '0.5rem',
          textAlign: 'center'
        }}>
          🔒 Styrelsen
        </h2>
        <p style={{
          textAlign: 'center',
          color: 'var(--text-soft)',
          fontSize: '0.9rem',
          marginBottom: '2rem'
        }}>
          Inloggning för styrelse och redaktörer
        </p>

        {error && (
          <div className="error" style={{ marginBottom: '1.5rem' }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">Användarnamn</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoFocus
              style={{ width: '100%' }}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Lösenord</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{ width: '100%' }}
            />
          </div>

          <button
            type="submit"
            className="btn btn-forest"
            disabled={loading}
            style={{ width: '100%', marginTop: '1rem' }}
          >
            {loading ? 'Loggar in...' : 'Logga in'}
          </button>
        </form>

        <div style={{
          marginTop: '2rem',
          paddingTop: '1.5rem',
          borderTop: '1px solid var(--border)',
          textAlign: 'center'
        }}>
          <Link to="/" style={{ color: 'var(--text-soft)', fontSize: '0.9rem' }}>
            ← Tillbaka till startsidan
          </Link>
        </div>
      </div>
    </div>
  );
}

function getRoleName(role) {
  const names = {
    admin: 'Administratör',
    contentCreator: 'Redaktör',
    sekreterare: 'Sekreterare',
    readOnly: 'Läsbehörig'
  };
  return names[role] || role;
}
